import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import { JMC_COLORS } from "../styles/colors";

/* Loader animation */
const loaderAnimation = keyframes`
  ${[...Array(10)].map(
  (_, i) => `${(i + 1) * 9.09}% {
      text-shadow: ${[...Array(10)]
      .map((_, j) => `calc(-${j}*var(--w)) ${i === j ? "-10px" : "0px"} #000`)
      .join(", ")};
    }`
).join("")}
`;

const lines = [
  "Processing your request...",
  "Please wait, this may take a few seconds...",
  "Thank you for your patience.",
];

const TYPING_SPEED = 45;
const HOLD_TIME = 2000;


const LoadingWithText = ({ style = 1 }) => {
  const [text, setText] = useState("");
  const [lineIndex, setLineIndex] = useState(0);

  useEffect(() => {
    let charIndex = 0;
    const interval = setInterval(() => {
      setText(lines[lineIndex].slice(0, ++charIndex));

      if (charIndex > lines[lineIndex].length) {
        clearInterval(interval);
        setTimeout(() => setLineIndex((prev) => (prev + 1) % lines.length), HOLD_TIME);
      }
    }, TYPING_SPEED);

    return () => clearInterval(interval);
  }, [lineIndex]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: "100px",
        left: "50%",
        transform: "translate(-50%, -40%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
        width: '100%',
        padding: "16px",
      }}
    >
      <Box >
        <Box
          sx={{
            width: { xs: "250px", sm: "380px" },
            margin: "0 auto",
            textAlign: "center",
            background: "linear-gradient(135deg, rgba(239, 246, 255, 0.85), rgba(219, 234, 254, 0.85))",
            // background: "linear-gradient(135deg, rgba(239, 246, 255, 0.55), rgba(219, 234, 254, 0.55))",
            borderRadius: "20px",
            padding: "16px",
            // border: "1px solid rgba(255, 255, 255, 0.35)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          }}
        >

          {/* Typewriting Text */}
          <Typography sx={{ color: JMC_COLORS.primary, minHeight: 28, fontSize: 16, fontWeight: 600, mb: 1 }}>
            {text}
          </Typography>

          {/* Loader */}
          <Box
            sx={{
              "--w": "10ch",
              fontWeight: "bold",
              fontFamily: "monospace",
              fontSize: "20px",
              letterSpacing: "var(--w)",
              width: "var(--w)",
              mx: "auto",
              overflow: "hidden",
              whiteSpace: "nowrap",
              color: JMC_COLORS.primary,
              textShadow: [
                JMC_COLORS.chemicals,
                JMC_COLORS.gas,
                JMC_COLORS.power,
                JMC_COLORS.water,
                JMC_COLORS.raw_material,
                JMC_COLORS.time,
                JMC_COLORS.miscellaneous,
                JMC_COLORS.dispatch,
                JMC_COLORS.power,
                JMC_COLORS.gas,
              ]
                .map((c, i) => `calc(-${i}*var(--w)) 0 ${c}`)
                .join(", "),
              animation: `${loaderAnimation} 2s infinite linear`,
              "&::before": { content: '"Loading..."' },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingWithText;
